import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'MenuRowSkeleton',
  values: {
    numberOfItems: 4,
    showIconPlaceholder: false,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '0',
          overflow: 'hidden',
        },
      },
    },
    itemContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '32px',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 0,
        },
      },
    },
    linkPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '100px',
          height: '40px',
        },
      },
    },
    iconPlaceholder: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '20px',
          height: '11px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
